class Toggler extends HTMLElement {
  constructor() {
    super();

    this.triggers = this.querySelectorAll('.toggler--trigger');
    this.target = this.querySelector('.toggler--target') || this;

    this._onClick = this._onClick.bind(this);
  }

  connectedCallback() {
    this.triggers.forEach((trigger) => trigger.addEventListener('click', this._onClick));
  }

  disconnectedCallback() {
    this.triggers.forEach((trigger) => trigger.removeEventListener('click', this._onClick));
  }

  _onClick(event) {
    const trigger = event.target.closest('.toggler--trigger');
    if (!trigger) return;

    // Accommodate nested togglers
    const parentToggler = trigger.closest('class-toggler');
    if (parentToggler !== this) return;

    this.toggle();
  }

  toggle() {
    this.target.classList.toggle('is-open');
  }
}

customElements.define('class-toggler', Toggler);
